<template>
  <v-app>
    <top-toolbar-back
      :title="title"
      :isGoHomeOnBack="isGoHomeOnBack"
      :renderNavigationButton="renderNavigationButton"
      :onBack="onBack"
    >
      <slot name="actions" />
    </top-toolbar-back>
    <v-main>
      <slot />
    </v-main>
  </v-app>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";

import ErrorAlert from "@/components/utility/ErrorAlert.vue";
import TopToolbarBack from "@/components/navigation/TopToolbarBack.vue";

@Component({ components: { ErrorAlert, TopToolbarBack } })
/**
 * A view that renders this layout brings its own `v-app`, so the route of the view has to set
 * `isStandaloneLayout` - otherwise the portal nests it below the `v-app` of its app shell,
 * see `TheAppShell` and `Portal.vue`.
 */
export default class LayoutSimple extends Vue {
  @Prop({ default: "" })
  title!: string;

  @Prop({ default: false })
  isGoHomeOnBack!: boolean;

  @Prop({ default: true })
  renderNavigationButton!: boolean;

  @Prop()
  onBack?: Function;
}
</script>

<style></style>
